module.exports = __webpack_public_path__ + "img/image15@2x.a53f0a16.png";